module.exports = __webpack_public_path__ + "static/media/series-poster-desktop.ed98632d.jpg";